<!--
 * @Descripttion: 用户协议组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zhangfan
 * @LastEditTime: 2024-12-11 11:51:58
-->
<template>
  <div class="user-agreement">
    <a-checkbox v-model="isAgreeValue" @change="isAgreeChange">
      <span style="font-size: 14px">{{$t('base.readAgreement')}}</span>
      <span style="color: #0166fc; font-size: 14px">{{$t('base.userAgreement')}}</span>
      <span style="font-size: 14px">{{$t('base.and')}}</span>
      <span style="color: #0166fc; font-size: 14px">{{$t('base.privacyPolicy')}}</span>
    </a-checkbox>
  </div>
</template>

<script>
import store from '@/store'
export default {
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
  },
  data: () => {
    return {
      isAgreeValue: false,
    }
  },
  watch:{
    isAgree: {
      handler(val){
        this.isAgreeValue = val
      },
      immediate: true
    }
  },
  methods: {
    isAgreeChange(e) {
      store.commit('user/SET_ISAgree', e.target.checked)
    },
  },
}
</script>

<style scoped>
.user-agreement {
  /* width: 460px; */
  margin-top: 20px;
  display: flex;
  align-items: center;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 14px;
}

.user-agreement span {
  color: #a2a5ae;
}
</style>
